module.exports = __webpack_public_path__ + "img/ast04.947f6707.svg";